import { useTranslation } from "@opendash/i18n";
import { Descriptions, Divider, Drawer, Flex, List, Tag } from "antd";
import { DescriptionsItemType } from "antd/es/descriptions";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { ScheduleWithBadge, useScheduleForSingleDate } from "..";
import { Schedule_Template } from "../../../js/parsegenerated";
import { OpenService } from "../../../types/config";
import { ScheduleCreationModalButton } from "./ScheduleCreationModalButton";

type Props = {
  open: boolean;
  onClose: () => void;
  date: Dayjs;
  onSave?: (schedule: Schedule_Template) => void;
};

export default observer((props: Props) => {
  const t = useTranslation();
  const [items, setItems] = useState<DescriptionsItemType[][]>([]);
  const { getSchedulesOnDate, refetchSchedulesOnDate, scheduleStates } =
    useScheduleForSingleDate();

  useEffect(() => {
    if (props.date === undefined) {
      return;
    }

    const fetchedItems = getSchedulesOnDate(props.date).map((scheduleState) => {
      return [
        {
          label: t("maintenance:schedule.template.detail.drawer.entries.title"),
          children: (
            <>
              <ScheduleWithBadge schedule={scheduleState.schedule} />
            </>
          ),
        },
        {
          label: t(
            "maintenance:schedule.template.detail.drawer.entries.description"
          ),
          children: scheduleState.schedule.get("description"),
        },
        {
          label: t(
            "maintenance:schedule.template.detail.drawer.entries.sources"
          ),
          children: (
            <Flex gap="middle" wrap="wrap">
              {scheduleState.sources.map((source) => (
                <Tag key={source.id}>{source.get("name")}</Tag>
              ))}
            </Flex>
          ),
        },
        {
          label: t("maintenance:schedule.template.detail.drawer.entries.steps"),
          children: (
            <List>
              {scheduleState.steps.map((step, index) => (
                <List.Item key={step.id + index}>
                  {index + 1}. {step.description}
                </List.Item>
              ))}
            </List>
          ),
        },
      ];
    });

    setItems(fetchedItems);
  }, [props.date, scheduleStates]);

  return (
    <Drawer
      open={props.open}
      onClose={props.onClose}
      closable
      title={t("maintenance:schedule.template.detail.drawer.title", {
        date: props.date.format(OpenService.Formats.date),
      })}
    >
      <ScheduleCreationModalButton
        date={props.date}
        onSave={(val) => {
          refetchSchedulesOnDate();
          props.onSave?.(val);
        }}
      />
      <Divider />
      {items.map((item, index) => (
        <Descriptions
          key={index}
          items={item}
          layout="vertical"
          column={1}
          size="small"
          bordered
          style={{ marginBottom: 24 }}
        />
      ))}
    </Drawer>
  );
});
